import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../type';

export const patientSelector = (state: RootState) => state.patient;

export const isPatientSelector = createSelector(patientSelector, (state) => state);
